<template>
  <div>
    <s-file-uploader-with-entity
      ref="wordUploader"
      :post-url="uploadFileUrl"
      extensions="doc,docx"
      accept=".doc,.docx"
      :maximum="1"
      :label="$t('Tools.UploadWordFile')"
      :response.sync="wordResponse"
      @uploadSuccess="onUploadSuccess"
      @uploadError="onUploadError"
    />
    <ul class="text-caption grey--text">
      <li>{{ $t('Outbox.Upload.AllowFileType') }}: doc, docx</li>
    </ul>
    <br>
    <s-file-uploader-with-entity
      ref="excelUploader"
      :post-url="uploadFileUrl"
      extensions="xls,xlsx"
      accept=".xls,.xlsx"
      :maximum="1"
      :label="$t('Tools.UploadExcelFile')"
      :response.sync="excelResponse"
      @uploadSuccess="onUploadSuccess"
      @uploadError="onUploadError"
    />
    <ul class="text-caption grey--text">
      <li>{{ $t('Outbox.Upload.AllowFileType') }}: xls, xlsx</li>
    </ul>
    <br>
    <v-btn
      :loading="loading"
      color="primary"
      @click="mergePrint"
    >
      {{ $t('Tools.MergePrint.MergeFile') }}
    </v-btn>
  </div>
</template>

<script>
import SFileUploaderWithEntity from '@/components/SFileUploaderWithEntity'
import { uploadMethod } from '@/mixins/uploadMethod'
import pdfApi from '@/api/tools/pdf'
import { globalModule } from '@/store/moduleName'
import stringUtil from '@/utils/stringUtil'

export default {
  components: {
    SFileUploaderWithEntity
  },
  mixins: [uploadMethod],
  data: function () {
    return {
      loading: false,
      wordResponse: [],
      excelResponse: []
    }
  },
  computed: {
    uploadFileUrl () {
      return this.$config.apiDomain.ALI + '/ext/ga/core-util-outbox/outbox/api/uploadFile'
    }
  },
  created () {
  },
  methods: {
    onUploadSuccess () {
    },
    mergePrint () {
      if (this.wordResponse.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsUpload', [this.$t('Tools.WordFile')]))
        return false
      }
      if (this.excelResponse.length === 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('Error.PlsUpload', [this.$t('Tools.ExcelFile')]))
        return false
      }
      this.loading = true
      pdfApi.dataMergeByExcel(this.excelResponse[0].response.instanceCode, this.wordResponse[0].response.instanceCode, stringUtil.filename(this.wordResponse[0].name), resp => {
        this.loading = false
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'pdfs.zip')
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    }
  }
}
</script>
